export default [

     {
          path: '/objective',
          name: 'Objective',
          component: () => import("@/views/Page/StrategicPlan/Objective/Objective.vue"),
           meta: {
               title: 'Objective',
          },
     }
];